import { apiRequest } from "../../util/api";
import voiceProto from "./voice-bot.proto";
import { Config } from "./config";

export interface BotSettings {
    prompt: string;
    greeting: string;
    language?: string;
    audioCodec?: string;
    ttsVoice?: string;
    ttsCodec?: string;
    ttsSpeed?: number;
    ttsInstructions?: string;
    temperature?: number;
}

export const getBotSettings = async (
    version: string,
    lang: string,
    isRealTime = false
): Promise<BotSettings> => {
    if (isRealTime) {
        return apiRequest({
            method: "get",
            baseUrl: Config.getSimulatorEndpoint(version, false),
            url: `/config`,
            isBlob: true,
        })
            .then((res: Blob) => res.arrayBuffer())
            .then((res) => {
                const {
                    language,
                    audioCodec,
                    ttsVoice,
                    ttsSpeed,
                    ttsCodec,
                    temperature,
                    instructions,
                    greeting,
                    tts_instructions,
                } = voiceProto.voice.Config.decode(new Uint8Array(res));

                return {
                    prompt: instructions || "",
                    greeting,
                    language,
                    audioCodec,
                    ttsVoice,
                    ttsCodec,
                    ttsSpeed: Math.round((ttsSpeed || 1) * 100) / 100,
                    ttsInstructions: tts_instructions || "",
                    temperature,
                };
            });
    }

    const { greeting } = await getGreeting(version, lang);
    const { prompt } = await apiRequest({
        method: "get",
        baseUrl: Config.getBotApiEndpoint(),
        url: `${Config.getBotApiPrefix(version)}/prompt?lang=${lang}`,
    });

    return {
        greeting,
        prompt,
        ttsInstructions: "",
    };
};

export const applyPrompt = async (version: string, lang: string, prompt: string) => {
    return apiRequest({
        method: "put",
        baseUrl: Config.getBotApiEndpoint(),
        url: `${Config.getBotApiPrefix(version)}/prompt`,
        data: {
            lang,
            prompt,
        },
    });
};

export const getGreeting = async (version: string, lang: string) => {
    return apiRequest({
        method: "get",
        baseUrl: Config.getBotApiEndpoint(),
        url: `${Config.getBotApiPrefix(version)}/greeting?lang=${lang}`,
    });
};

export const applyGreeting = async (version: string, lang: string, greeting: string) => {
    return apiRequest({
        method: "put",
        baseUrl: Config.getBotApiEndpoint(),
        url: `${Config.getBotApiPrefix(version)}/greeting`,
        data: {
            lang,
            greeting,
        },
    });
};

export const generateAnswer = async (
    version: string,
    lang: string,
    messages: {
        role: "user" | "assistant";
        content: string;
    }[]
) => {
    return apiRequest({
        method: "post",
        baseUrl: Config.getBotApiEndpoint(),
        url: `${Config.getBotApiPrefix(version)}/generate`,
        data: { messages, lang, context: {} },
    });
};

// Re-export for backward compatibility
export const getSimulatorEndpoint = Config.getSimulatorEndpoint.bind(Config);
